import { render, staticRenderFns } from "./ScoreboardFOResumeAction.vue?vue&type=template&id=91cfd650"
import script from "./ScoreboardFOResumeAction.vue?vue&type=script&lang=js"
export * from "./ScoreboardFOResumeAction.vue?vue&type=script&lang=js"
import style0 from "./ScoreboardFOResumeAction.vue?vue&type=style&index=0&id=91cfd650&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports